import { render } from "./upload-salary-step2.vue?vue&type=template&id=31de9a40&scoped=true&ts=true"
import script from "./upload-salary-step2.vue?vue&type=script&lang=ts"
export * from "./upload-salary-step2.vue?vue&type=script&lang=ts"

import "./upload-salary-step2.vue?vue&type=style&index=0&id=31de9a40&lang=stylus&scoped=true"

import exportComponent from "E:\\code\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31de9a40"]])

export default __exports__